import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { homeSlidesResolver } from './pages/home/slide/home-slides.resolver';
import { cartGuard } from './core/guards/cart.guard';
import { authGuard, authOrGuestGuard, guestCheckoutPaymentGuard, guestGuard, logoutGuestGuard, paymentResultGuard } from './core/guards/auth.guard';
import { CartGuardService } from './core/guards/cart.guard.service';
import { clearPaymentResultGuard } from '@components/checkout/guards/clear-payment-result.guard';
import { clearCookieGuard } from '@components/checkout/guards/clear-cookie.guard';

export const routes: Routes = [
    {
        path: '',
        /* pathMatch: 'full', */
        component: HomeComponent,
        resolve: { slides: homeSlidesResolver },
    },
    {
        path: 'home',
        pathMatch: 'full',
        component: HomeComponent,
        resolve: { slides: homeSlidesResolver },
    },

    /**************************************************************** TEST URL *********************************************************************/
    {
        path: 'test01/:idindice',
        /* pathMatch: 'full', */
        loadComponent: () => import('./components/_test/test01/test01.component').then(c => c.Test01Component),
    },

    /**************************************************************** //TEST URL *********************************************************************/

    /**************************************************************** INDICE CATALOGO *********************************************************************/

    /* PRIMO LIVELLO */
    {
        path: 'c/i/:seoname/:idindice',
        /* pathMatch: 'full', */
        loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent),
    },
    /* SECONDO LIVELLO */
    {
        path: 'c/i/:seoname/:seonamefiglio/:idindice',
        /* pathMatch: 'full', */
        loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent),
    },
    /* TERZO LIVELLO */
    {
        path: 'c/i/:seoname/:seonamefiglio/:seonamefiglio2/:idindice',
        /* pathMatch: 'full', */
        loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent),
    },
    /* QUARTO LIVELLO: l'URL canonico usa solo gli ultimi 3 seoname (come breadcrumb) → redirect */
    {
        path: 'c/i/:seoname/:seonamefiglio/:seonamefiglio2/:seonamefiglio3/:idindice',
        redirectTo: '/c/i/:seonamefiglio/:seonamefiglio2/:seonamefiglio3/:idindice',
    },


    /***RICERCA PER CATEGORIA Indice di categoria****/
    {
        path: 'c/c/:seoname/:idcategoria',
        pathMatch: 'full',
        loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent)
    },

    /*****************************************RICERCA************************************* */
    /******** ricerca senza query param ******/
    { path: 'ricerca', redirectTo: '/home', pathMatch: 'full' },
    { path: 'rechercher', redirectTo: '/home', pathMatch: 'full' },
    { path: 'search', redirectTo: '/home', pathMatch: 'full' },
    { path: 'suchen', redirectTo: '/home', pathMatch: 'full' },
    { path: 'buscar', redirectTo: '/home', pathMatch: 'full' },
    /********Ricerca by query in box ricerca */
    {
        path: 'ricerca/:query',
        pathMatch: 'full',
        loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent),
    },
    { path: 'rechercher/:query', loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent), },
    { path: 'search/:query', loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent), },
    { path: 'suchen/:query', loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent), },
    { path: 'buscar/:query', loadComponent: () => import('./components/catalog/catalog.component').then(m => m.CatalogComponent), },

    
    /**************************************************************** ARTICOLI *********************************************************************/
    {
        path: 'p/:seoname/:idarticolo',
        pathMatch: 'full',
        loadComponent: () => import('./components/articolo/articolo.component').then(m => m.ArticoloComponent),
    },
    {
        path: 'p/:seoname/:idarticolo/:lang',
        pathMatch: 'full',
        loadComponent: () => import('./components/articolo/articolo.component').then(m => m.ArticoloComponent),
    },

    /**************************************************************** RICAMBI *********************************************************************/
    {
        path: 'r/:seoname/:idarticolo',
        pathMatch: 'full',
        loadComponent: () => import('./components/articolo/articolo.component').then(m => m.ArticoloComponent),
    },
    {
        path: 'r/:seoname/:idarticolo/:lang',
        pathMatch: 'full',
        loadComponent: () => import('./components/articolo/articolo.component').then(m => m.ArticoloComponent),
    },

    /********************************************************* ROUTE STATICHE SIDEBAR ********************************************************************/

    /****************************************************************** RICAMBI **************************************************************************/
    {
        path: 'ricambi',
        pathMatch: 'full',
        loadComponent: () => import('./components/ricambi/ricambi.component').then(m => m.RicambiComponent)
    },
    { path: 'pièces-détachées', pathMatch: 'full', loadComponent: () => import('./components/ricambi/ricambi.component').then(m => m.RicambiComponent) },
    { path: 'spare-parts', pathMatch: 'full', loadComponent: () => import('./components/ricambi/ricambi.component').then(m => m.RicambiComponent) },
    { path: 'ersatzteile', pathMatch: 'full', loadComponent: () => import('./components/ricambi/ricambi.component').then(m => m.RicambiComponent) },
    { path: 'repuestos', pathMatch: 'full', loadComponent: () => import('./components/ricambi/ricambi.component').then(m => m.RicambiComponent) },

    /**************************************************************** CHI SIAMO **************************************************************************/
    {
        path: 'chi-siamo',
        pathMatch: 'full',
        /*
            guard per proteggere route che devono avere il carrello
            + servizio con effect per redirect se il carrello si svuota quando la route è già stata attivata
            canActivate: [cartGuard],
            providers: [CartGuardService],
        */
        loadComponent: () => import('./pages/chi-siamo/chi-siamo.component').then(m => m.ChiSiamoComponent)
    },
    { path: 'qui-sommes-nous', pathMatch: 'full', loadComponent: () => import('./pages/chi-siamo/chi-siamo.component').then(m => m.ChiSiamoComponent) },
    { path: 'about-us', pathMatch: 'full', loadComponent: () => import('./pages/chi-siamo/chi-siamo.component').then(m => m.ChiSiamoComponent) },
    { path: 'wer-sind-wir', pathMatch: 'full', loadComponent: () => import('./pages/chi-siamo/chi-siamo.component').then(m => m.ChiSiamoComponent) },
    { path: 'quienes-somos', pathMatch: 'full', loadComponent: () => import('./pages/chi-siamo/chi-siamo.component').then(m => m.ChiSiamoComponent) },

    /*************************************************************** DOVE SIAMO *************************************************************************/

    {
        path: 'dove-siamo',
        pathMatch: 'full',
        loadComponent: () => import('./pages/dove-siamo/dove-siamo.component').then(m => m.DoveSiamoComponent)
    },
    { path: 'ou-sommes-nous', pathMatch: 'full', loadComponent: () => import('./pages/dove-siamo/dove-siamo.component').then(m => m.DoveSiamoComponent) },
    { path: 'operating-location', pathMatch: 'full', loadComponent: () => import('./pages/dove-siamo/dove-siamo.component').then(m => m.DoveSiamoComponent) },
    { path: 'wo-sind-wir', pathMatch: 'full', loadComponent: () => import('./pages/dove-siamo/dove-siamo.component').then(m => m.DoveSiamoComponent) },
    { path: 'donde-estamos', pathMatch: 'full', loadComponent: () => import('./pages/dove-siamo/dove-siamo.component').then(m => m.DoveSiamoComponent) },

    /********************************************************** SPEDIZIONI e PAGAMENTI ********************************************************************/

    {
        path: 'spedizioni-e-pagamenti',
        pathMatch: 'full',
        loadComponent: () => import('./pages/spedizioni-pagamenti/spedizioni-pagamenti.component').then(m => m.SpedizioniPagamentiComponent)
    },
    { path: 'livraison-et-paiement', pathMatch: 'full', loadComponent: () => import('./pages/spedizioni-pagamenti/spedizioni-pagamenti.component').then(m => m.SpedizioniPagamentiComponent) },
    { path: 'ship-and-payment', pathMatch: 'full', loadComponent: () => import('./pages/spedizioni-pagamenti/spedizioni-pagamenti.component').then(m => m.SpedizioniPagamentiComponent) },
    { path: 'versand-und-zahlung', pathMatch: 'full', loadComponent: () => import('./pages/spedizioni-pagamenti/spedizioni-pagamenti.component').then(m => m.SpedizioniPagamentiComponent) },
    { path: 'envios-y-pagos', pathMatch: 'full', loadComponent: () => import('./pages/spedizioni-pagamenti/spedizioni-pagamenti.component').then(m => m.SpedizioniPagamentiComponent) },

    /********************************************************** SPEDIZIONI e PAGAMENTI ********************************************************************/

    {
        path: 'dati-azienda',
        pathMatch: 'full',
        loadComponent: () => import('./pages/dati-azienda/dati-azienda.component').then(m => m.DatiAziendaComponent)
    },
    { path: 'coordonnees-de-la-societe', pathMatch: 'full', loadComponent: () => import('./pages/dati-azienda/dati-azienda.component').then(m => m.DatiAziendaComponent) },
    { path: 'company-data', pathMatch: 'full', loadComponent: () => import('./pages/dati-azienda/dati-azienda.component').then(m => m.DatiAziendaComponent) },
    { path: 'firmendaten', pathMatch: 'full', loadComponent: () => import('./pages/dati-azienda/dati-azienda.component').then(m => m.DatiAziendaComponent) },
    { path: 'datos-empresa', pathMatch: 'full', loadComponent: () => import('./pages/dati-azienda/dati-azienda.component').then(m => m.DatiAziendaComponent) },

    /***************************************************************** PRIVACY ***************************************************************************/

    {
        path: 'privacy',
        pathMatch: 'full',
        loadComponent: () => import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent)
    },

    /************************************************************** NOSTRI STORE *************************************************************************/

    {
        path: 'negozi',
        pathMatch: 'full',
        loadComponent: () => import('./pages/nostri-store/nostri-store.component').then(m => m.NostriStoreComponent)
    },
    { path: 'tiendas', pathMatch: 'full', loadComponent: () => import('./pages/nostri-store/nostri-store.component').then(m => m.NostriStoreComponent) },
    { path: 'magasins', pathMatch: 'full', loadComponent: () => import('./pages/nostri-store/nostri-store.component').then(m => m.NostriStoreComponent) },
    { path: 'store', pathMatch: 'full', loadComponent: () => import('./pages/nostri-store/nostri-store.component').then(m => m.NostriStoreComponent) },
    { path: 'geschafte', pathMatch: 'full', loadComponent: () => import('./pages/nostri-store/nostri-store.component').then(m => m.NostriStoreComponent) },

    /**************************************************************** AUTENTICAZIONE ********************************************************************/
    {
        path: 'login',
        canActivate: [guestGuard],
        pathMatch: 'full',
        loadComponent: () => import('./components/auth/login/login.component').then(m => m.LoginComponent),
    },

    /**************************************************************** PWD DIMENTICATA ********************************************************************/
    {
        path: 'login/reset-password',
        canActivate: [guestGuard],
        pathMatch: 'full',
        loadComponent: () => import('./components/auth/password-dimenticata/password-dimenticata.component').then(m => m.PasswordDimenticataComponent),
    },

    /****************************************************************** PWD RESET ************************************************************************/
    {
        path: 'login/password-reset/:userkey',
        canActivate: [guestGuard],
        pathMatch: 'full',
        loadComponent: () => import('./components/auth/password-reset/password-reset.component').then(m => m.PasswordResetComponent),
    },

    /******************************************************************** REDIRECT ***********************************************************************/
    {
        path: 'redirect/:idcliente/:target/:redirect_uk/:register/:local_storage',
        pathMatch: 'full',
        loadComponent: () => import('./components/auth/redirect/redirect.component').then(m => m.RedirectComponent),
    },

    /**************************************************************** REGISTRAZIONE *********************************************************************/
    {
        path: 'registrazione',
        pathMatch: 'full',
        loadComponent: () => import('./components/auth/registrazione/registrazione.component').then(m => m.RegistrazioneComponent),
    },
    { path: 'subscribe', pathMatch: 'full', loadComponent: () => import('./components/auth/registrazione/registrazione.component').then(m => m.RegistrazioneComponent) },
    { path: 'inscription', pathMatch: 'full', loadComponent: () => import('./components/auth/registrazione/registrazione.component').then(m => m.RegistrazioneComponent) },
    { path: 'anmelden', pathMatch: 'full', loadComponent: () => import('./components/auth/registrazione/registrazione.component').then(m => m.RegistrazioneComponent) },
    { path: 'registro', pathMatch: 'full', loadComponent: () => import('./components/auth/registrazione/registrazione.component').then(m => m.RegistrazioneComponent) },

    /**************************************************************** BLOG*********************************************************************/
    {
        path: 'blog',
        loadComponent: () => import('./components/blog/blog.component').then(c => c.BlogComponent),

        children: [
            {
                path: '',
                loadComponent: () => import('./components/blog/posts/posts.component').then(c => c.PostsComponent)
            },
            {
                path: 'search/:query',
                loadComponent: () => import('./components/blog/posts-search/posts-search.component').then(c => c.PostsSearchComponent)
            },
            {
                path: 'categorie/:seoname/:idcategoria',
                loadComponent: () => import('./components/blog/categorie/categorie.component').then(c => c.CategorieComponent)
            },/*
            {
                path: 'tags/:seoname',
                loadComponent: () => import('./components/blog/tags/tags.component').then(c => c.TagsComponent)
            },*/
            {
                path: ':seoname',
                loadComponent: () => import('./components/blog/article/article.component').then(c => c.ArticleComponent)
            }
        ]
    },

    /**************************************************************** WISH LIST ********************************************************************/

    {
        path: 'wishlist',
        loadComponent: () => import('./components/wishlist/wishlist.component').then(c => c.WishlistComponent)
    },

    /**************************************************************** USER AREA ********************************************************************/

    {
        path: 'userarea',
        canActivate: [authGuard],
        loadComponent: () => import('./components/user-area/user-area.component').then(u => u.UserAreaComponent),

        children: [
            {
                path: 'account',
                loadComponent: () => import('./components/user-area/account/account.component').then(c => c.AccountComponent)
            },
            {
                path: 'assistenza',
                loadComponent: () => import('./components/user-area/assistenza/assistenza.component').then(c => c.AssistenzaComponent)
            },
            {
                path: 'dashboard',

                loadComponent: () => import('./components/user-area/dashboard/dashboard.component').then(c => c.DashboardComponent)
            },
            {
                path: 'indirizzi',
                loadComponent: () => import('./components/user-area/indirizzi/indirizzi.component').then(c => c.IndirizziComponent)
            },
            {
                path: 'ordini',
                loadComponent: () => import('./components/user-area/ordini/ordini.component').then(c => c.OrdiniComponent)
            },
            {
                path: 'wishlist',
                loadComponent: () => import('./components/wishlist/wishlist.component').then(c => c.WishlistComponent)
            }
        ]
    },

    /**************************************************************** CHECKOUT *********************************************************************/
    {
        path: 'checkout',
        canActivate: [authGuard, clearCookieGuard],
        loadComponent: () => import('./components/checkout/checkout.component').then(c => c.CheckoutComponent)
    },
    {
        path: 'checkout/pagamento',
        canActivate: [authOrGuestGuard, clearPaymentResultGuard], // sia logged che guest
        loadComponent: () => import('./components/checkout/C00/pagamento/pagamento.component').then(c => c.PagamentoComponent),
    },
    {path: 'checkout/payment', canActivate: [authOrGuestGuard, clearPaymentResultGuard], loadComponent: () => import('./components/checkout/C00/pagamento/pagamento.component').then(c => c.PagamentoComponent),},
    {path: 'checkout/paiement', canActivate: [authOrGuestGuard, clearPaymentResultGuard], loadComponent: () => import('./components/checkout/C00/pagamento/pagamento.component').then(c => c.PagamentoComponent),},
    {path: 'checkout/pago', canActivate: [authOrGuestGuard, clearPaymentResultGuard], loadComponent: () => import('./components/checkout/C00/pagamento/pagamento.component').then(c => c.PagamentoComponent),},
    {path: 'checkout/zahlung', canActivate: [authOrGuestGuard, clearPaymentResultGuard], loadComponent: () => import('./components/checkout/C00/pagamento/pagamento.component').then(c => c.PagamentoComponent),},

    /************************************************************** FAST-CHECKOUT *******************************************************************/
    {
        path: 'checkout/fast', // registrazione fast checkout
        canActivate: [logoutGuestGuard, clearCookieGuard], // slogga i guest
        loadComponent: () => import('./components/checkout/fast-checkout/001-registrazione/fast-checkout-registration.component').then(c=>c.FastCheckoutRegistrationComponent)
    },
    
    {
        path: 'checkout/fast/pagamento', // ripilogo e scelta spedizione
        canActivate: [guestCheckoutPaymentGuard], // solo guest
        loadComponent: () => import('./components/checkout/fast-checkout/002-checkout/fast-checkout/fast-checkout.component').then(c => c.FastCheckoutComponent) // componente specifico per guest
    },
    {path: 'checkout/fast/payment', canActivate: [guestCheckoutPaymentGuard], loadComponent: () => import('./components/checkout/fast-checkout/002-checkout/fast-checkout-spedition/fast-chechout-spedition.component').then(c => c.FastChechoutSpeditionComponent),},
    {path: 'checkout/fast/paiement', canActivate: [guestCheckoutPaymentGuard], loadComponent: () => import('./components/checkout/fast-checkout/002-checkout/fast-checkout-spedition/fast-chechout-spedition.component').then(c => c.FastChechoutSpeditionComponent),},
    {path: 'checkout/fast/pago', canActivate: [guestCheckoutPaymentGuard], loadComponent: () => import('./components/checkout/fast-checkout/002-checkout/fast-checkout-spedition/fast-chechout-spedition.component').then(c => c.FastChechoutSpeditionComponent),},
    {path: 'checkout/fast/zahlung', canActivate: [guestCheckoutPaymentGuard], loadComponent: () => import('./components/checkout/fast-checkout/002-checkout/fast-checkout-spedition/fast-chechout-spedition.component').then(c => c.FastChechoutSpeditionComponent),},

    
    {
        // non serve, uso la stessa dei logged ****************************
        path: 'checkout/pagamento/fast',  // scelta gateway pagamento
        canActivate: [guestCheckoutPaymentGuard], // solo guest
        loadComponent: () => import('./components/checkout/C00/pagamento/pagamento.component').then(c => c.PagamentoComponent) // stesso componente dei logged
    },

    /************************************************** CONDIVISE CHECKOUT e FAST-CHECKOUT ***********************************************************/
    {
        path: 'checkout/esito',
        canActivate: [authOrGuestGuard],
        loadComponent: () => import('./components/checkout/D00/esito/esito.component').then(c => c.EsitoComponent)
    },

    {
        path: 'esito-stripe-redirect/:idcliente/:idcarrello',
        canActivate: [authOrGuestGuard],
        loadComponent: () => import('./components/checkout/D00/esito/stripe-redirect/stripe-redirect.component').then(c => c.StripeRedirectComponent)
    },
    {
        path: 'checkout/esito/success',
        canActivate: [paymentResultGuard, logoutGuestGuard],
        loadComponent: () => import('./components/checkout/D00/esito/success/success.component').then(c => c.SuccessComponent)
    },
    {
        path: 'checkout/esito/pending',
        canActivate: [authOrGuestGuard],
        loadComponent: () => import('./components/checkout/D00/esito/pending/pending.component').then(c => c.PendingComponent)
    },
    {
        path: 'checkout/esito/error',
        canActivate: [authOrGuestGuard],
        loadComponent: () => import('./components/checkout/D00/esito/error/error.component').then(c => c.ErrorComponent)
    },
    {
        path: 'checkout/esito/ordine-error',
        canActivate: [authOrGuestGuard],
        loadComponent: () => import('./components/checkout/D00/esito/ordine-error/ordine-error.component').then(c => c.OrdineErrorComponent)
    },

    /************************************************** BANNER PROMO ***********************************************************/
    {
        path: 'banner-promo',
        loadComponent: () => import('./components/banner-promo/banner-promo.component').then(c => c.BannerPromoComponent)
    },

    /************************************************** SOFT 404 ***********************************************************/
    {
        path: 'page-not-found',
        pathMatch: 'full',
        loadComponent: () => import('./components/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
    },
    {
        path: '**',
        loadComponent: () => import('./components/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
    }

];